class Stack {
  constructor(args) {
    this.array = []
    this.length = 0
    this.type = 'stack'
    if (args && args === document) {
      this.array[0] = document
      this[0] = document
    } else if (Array.isArray(args)) {
      let i = -1
      const len = args.length
      while (++i < len) {
        this.array[i] = args[i]
      }
    } else {
      const array = Array.prototype.slice.apply(arguments)
      array.forEach(function(ctx, idx) {
        this.array[idx] = ctx
      })
    }
  }

  eq(index) {
    const ret = new Stack()
    if (!this.array.length) return ret
    let temp
    if (index < 0) {
      temp = this.array[this.array.length + index]
      ret.push(temp)
    } else {
      if (index >= this.array.length) return new Stack()
      temp = this.array[index]
      ret.push(temp)
    }
    ret[0] = ret.array[0]
    return ret
  }

  push(data) {
    if (data && data.objectType === 'Stack') {
      this.array = this.array.concat(data.array)
      this[0] = this.array
    } else {
      this.array.push(data)
    }
  }

  pop() {
    let ret = this.array.pop()
    ret = $(ret)
    ret[0] = ret.array[0]
    return ret
  }

  unshift(data) {
    if (data && data.objectType === 'Stack') {
      this.array.unshift(data.array[0])
      this[0] = this.array[0]
    } else {
      this.array.unshift(data)
      this[0] = this.array[0]
    }
  }

  shift() {
    let ret = this.array.shift()
    ret = $(ret)
    ret[0] = ret.array[0]
    return ret
  }

  forEach(callback) {
    let value
    let i = 0
    const len = this.array.length
    for (; i < len; i++) {
      value = callback.call(this.array[i], this.array[i], i)
      if (value === false) {
        break
      }
    }
  }

  slice(...args) {
    let ret = new Stack()
    ret.concat(this.array.slice.apply(this.array, args))
    ret = $(ret)
    ret[0] = ret.array[0]
    return ret
  }

  splice(...args) {
    let ret = new Stack()
    ret.concat(this.array.splice.apply(this.array, args))
    ret = $(ret)
    ret[0] = ret.array[0]
    return ret
  }

  filter(...args) {
    let ret = new Stack()
    ret.concat(this.array.filter.apply(this.array, args))
    ret[0] = ret.array[0]
    ret = $(ret)
    ret[0] = ret.array[0]
    return ret
  }

  map(...args) {
    let ret = new Stack()
    ret.concat(this.array.map.apply(this.array, args))
    ret[0] = ret.array[0]
    ret = $(ret)
    ret[0] = ret.array[0]
    return ret
  }

  indexOf(node) {
    if (!node) return -1
    if (node.nodeType && node.nodeType === 1) {
      return this.array.indexOf(node)
    } else if (node && node.objectType === 'Stack') {
      return this.array.indexOf(node[0])
    } else if (node && Array.isArray(node)) {
      return this.array.indexOf(node[0])
    } else if (node && $.type(node) === 'string') {
      const el = this[0].parentNode.querySelector(node)
      return this.array.indexOf(el)
    }
  }

  concat(collection) {
    const self = this
    if (collection && Array.isArray(collection.array)) {
      this.array = this.array.concat(collection.array)
    } else if (collection && collection.constructor.toString().match(/HTMLLIElement/)) {
      this.array.push(collection)
    } else if (collection && Array.isArray(collection)) {
      collection.forEach(function(item) {
        self.array.push(item)
      })
    }
  }

  reverse(...args) {
    this.array.reverse.apply(this.array, args)
    this[0] = this.array[0]
  }

  unique() {
    const ret = []
    const sort = this.array.sort()
    sort.forEach((ctx) => {
      if (ret.indexOf(ctx) === -1) {
        ret.push(ctx)
      }
    })
    ret.sort(function(a, b) {
      return a - b
    })
    this.array.splice(0)
    const self = this.array
    ret.forEach(function(node) {
      self.push(node)
    })
  }

  purge() {
    this.array.length = 0
  }

  find(selector, context) {
    let ret = new Stack()
    let matches
    if (!this.array.length)
      return ret
    if (context) {
      $(context).forEach(function() {
        matches = Array.prototype.slice.apply(context.querySelectorAll(selector))
        matches.forEach(function(node) {
          ret.array.push(node)
        })
      })
    } else {
      this.forEach(function(ctx) {
        if (ctx && ctx.children && ctx.children.length) {
          matches = Array.prototype.slice.apply(ctx.querySelectorAll(selector))
          matches.forEach(function(node) {
            ret.array.push(node)
          })
        }
      })
    }
    ret[0] = ret.array[0]
    return ret
  }

  is(arg) {
    let ret = false
    if (!this.array.length || !arg) return
    if (!this.array.length) return
    const self = this
    const __is = function(node, arg) {
      if (typeof arg === 'string') {
        let nodes
        if (node.parentNode) nodes = node.parentNode.querySelectorAll(arg)
        let elements
        if (nodes && nodes.length) {
          elements = Array.prototype.slice.apply(node.parentNode.querySelectorAll(arg))
        }
        if (elements && elements.length) {
          if (elements.indexOf(node) >= 0) {
            ret = true
          }
        }
      } else if (typeof arg === 'function') {
        if (arg.call(self)) {
          ret = true
        }
      } else if (arg && arg.type && arg.type === 'Stack') {
        if (node === arg[0]) {
          ret = true
        }
      } else if (arg && arg.length) {
        if (this.slice.apply(arg).indexOf(node) !== -1) {
          ret = true
        }
      } else if (arg.nodeType === 1) {
        if (node === arg) {
          ret = true
        }
      } else {
        return
      }
      return ret
    }
    this.forEach(function(item) {
      if (__is(item, arg)) {
        ret = true
      }
    })
    return ret
  }

  index(selector) {
    const self = this.array
    if (!this.array.length) {
      return
    }

    function getIndex() {
      const result = self.findIndex(function(el) {
        return $(el).is(selector)
      })
      return result
    }

    if (selector && typeof selector === 'string') {
      return getIndex(selector)

    } else if (selector && selector.type && selector.type === 'Stack') {
      return getIndex(selector[0])

    } else if (selector && selector.nodeType && selector.nodeType === 1) {
      return getIndex(selector)

    } else {
      if (self.length > 1) {
        return 0
      }
      const siblings = Array.prototype.slice.apply(self[0].parentNode.children)
      return siblings.findIndex(function(el) {
        return el === self[0]
      })
    }
  }

  siblings(selector) {
    if (!this.array.length)
      return new Stack()
    let __siblings
    let ret = new Stack()
    const self = this
    const pos =  this.index()
    let parent
    const children = Array.prototype.slice.apply(self.array[0].parentNode.children)
    if (selector && typeof selector === 'string') {
      parent = this.array[0].parentNode
      __siblings = Array.prototype.slice.apply(parent.querySelectorAll(selector))
      const newPos = __siblings.indexOf(self.array[0])
      __siblings.splice(newPos, 1)
      ret.concat(__siblings)
      ret[0] = ret.array[0]
      return ret
    } else {
      children.splice(pos, 1)
      ret.array = children
      ret[0] = ret.array[0]
      return ret
    }
  }

  closest(selector) {
    if (!this.array.length) {
      return new Stack()
    }
    const ret = new Stack()
    if (typeof selector === 'undefined') {
      return new Stack()
    }
    let p
    if (this.array[0]) {
      p = this.array[0].parentNode
    }
    if (!p) {
      return new Stack()
    }
    if (typeof selector === 'string') {
      selector.trim()
      if (p && $(p).is(selector)) {
        ret.array.push(p)
      } else {
        ret.array.push($(p).closest(selector).array[0])
      }
    }
    if (ret.array[0] === undefined) {
      ret.splice(0)
    }
    ret[0] = ret.array[0]
    return ret
  }

  css(property, value) {
    if (!this.array.length) return new Stack()
    const pixelRE = /top|bottom|left|right|margin|padding/img
    let postFix = ''
    const ret = new Stack()
    const testForPixelSupport = function(value, property) {
      if (value === 'number' && property.match(pixelRE)) {
        postFix = 'px'
      }
    }
    if (!property) return new Stack()
    if (!value && typeof property === 'object' && !Array.isArray(property)) {
      this.forEach(function(node) {
        for (let key in property) {
          if (property.hasOwnProperty(key)) {
            testForPixelSupport(property[key], key)
            node.style[$.camelize(key)] = property[key] + postFix
          }
        }
        ret.push(node)
      })
    } else if (!value && typeof property === 'string') {
      if (!this.array.length)
        return
      return document.defaultView.getComputedStyle(this.eq(0).array[0], null).getPropertyValue(property.toLowerCase())
    } else if (!!value) {
      this.forEach(function(node) {
        testForPixelSupport(value, property)
        node.style[$.camelize(property)] = value + postFix
        ret.push(node)
      })
    }
    ret[0] = ret.array[0]
    return ret
  }

  before(content) {
    if (!this.array || !this.array.length) {
      return new Stack()
    }
    const self = this
    const __before = function(node, content) {
      if (typeof content === 'string' || typeof content === 'number') {
        content = $.h(content)
      }
      if (content && content.type && content.type === 'stack') {
        const len = content.array.length
        let i = 0
        while (i < len) {
          node.parentNode.insertBefore(content.array[i], node)
          i++
        }
      } else if (content && content.nodeType === 1) {
        node.parentNode.insertBefore(content, node)
      } else if (content && content.nodeType == 11) {
      self.forEach(function() {
        node.parentNode.insertBefore(content, node)
      })
    }
      self[0] = self.array[0]
      return self
    }
    self.forEach(function(node) {
      return __before(node, content)
    })
    self[0] = self.array[0]
    return this
  }

  after(content) {
    if (!this.array || !this.array.length) return new Stack()
    const self = this
    const __after = (children) => {
      children.forEach(function(node) {
        self.array.forEach(function(el) {
          if (el.nextElementSibling) {
            el.parentNode.insertBefore(node, el.nextElementSibling)
          } else {
            el.parent.appendChild(node)
          }
        })
      })
    }
    if (typeof content === 'string') {
      content = $.h(content)
    }
    if (content && content.type === 'stack') {
      if (content && content.array && !content.array.length) return
      __after(content.array)
    } else if (content && (content.nodeType === 1 || content.nodeType === 3)) {
      self.forEach(function(el) {
        __after([content])
      })
    } else if (content && content.nodeType === 11) {
      const children = Array.prototype.slice.apply(content.childNodes)
      __after(children)
    }
    self[0] = this.array[0]
    return self
  }

  prepend(content) {
    if (!this.array.length) return new Stack()

    if (typeof content === 'string' || typeof content === 'number') {
      this.forEach(function(element) {
        element.insertAdjacentHTML('afterbegin', content)
      })
    } else if (content && content.type && content.type === 'Stack') {
      this.forEach(function(element) {
        content.forEach(function(node) {
          element.insertBefore(node, element.firstChild)
        })
      })
    } else if (content && content.nodeType === 1) {
      this.forEach(function(element) {
        element.insertBefore(content, element.firstChild)
      })
    } else if (content && content.nodeType == 11) {
      this.forEach(function(element) {
        element.appendChild(content)
      })
    }
    this[0] = this.array[0]
    return this
  }

  append(content) {
    if (!this.array.length) return new Stack()

    if (typeof content === 'string' || typeof content === 'number') {
      this.forEach(function(element) {
        element.insertAdjacentHTML('beforeend', content)
      })
    } else if (content && content.type && content.type === 'Stack') {
      this.forEach(function(element) {
        content.forEach(function(node) {
          element.insertBefore(node, null)
        })
      })

    } else if (content && content.nodeType === 1) {
      this.forEach(function(element) {
        element.insertBefore(content, null)
      })
    } else if (content && content.nodeType == 11) {
      this.forEach(function(element) {
        element.appendChild(content)
      })
    }
    this[0] = this.array[0]
    return this
  }

  empty() {
    if (!this.array.length) return new Stack()
    const ret = new Stack()
    this.array.forEach(function(ctx) {
      ctx.textContent = ''
      ret.push(ctx)
    })
    ret[0] = ret.array[0]
    return ret
  }

  replaceWith(content) {
    function replace(newElement, targetElement) {
      if (!newElement || !targetElement) return
      let newEl
      let targEl
      if (typeof newElement === 'string') {
        newEl = $.h(newElement)
      } else if (newElement.type && newElement.type === 'stack') {
        newEl = newElement.array[0]
      } else if (newElement.nodeType === 1 || newElement.nodeType === 11) {
        newEl = newElement
      }
      if (typeof targetElement === 'string') {
        targEl = $(targetElement).array[0]
      } else if (targetElement.type && targetElement.type === 'stack') {
        targEl = targetElement.array[0]
      } else if (targetElement.nodeType === 1) {
        targEl = targetElement
      }
      /**
       * Remove target's bound events:
       */
      $(targEl).off()
      targEl.parentNode.replaceChild(newEl, targEl)
    }
    if (content && content.nodeType && content.nodeType === 1) {
      $(content).off()
    } else if (content && content.type && content.type === 'stack') {
      content.off()
    }
    this.forEach(function(node) {
      $(node).off()
        replace(content, node)
    })
  }

  remove() {
    if (!this.array.length) return new Stack()
    this.forEach(function(node) {
      $(node).off()
      if (node.parentNode) node.parentNode.removeChild(node)
    })
  }

  text(string) {
    let ret = ''
    if (!this.array.length) return new Stack()
    if (!!string || string === 0) {
      this.forEach(function(element) {
        element.innerText = string
      })
      return this
    } else {
      this.forEach(function(element) {
        ret += element.innerText
        ret.trim()
      })
      return ret
    }
  }

  html(markup) {
    if (!this.array.length) return new Stack()
    if (markup === '') {
      this.array.forEach(node => {
        node.innerHTML = ''
      })
      return this
    } else if (markup) {
      this.array.forEach(node => {
        node.innerHTML = markup
      })
      return this
    } else if (!markup) {
      return this.array[0].innerHTML.trim()
    }
  }

  val(value) {
    if (!this.array.length) return new Stack()
    if (value || value === '') {
      this.array[0].value = value
      this[0] = this.array[0]
      return this
    } else {
      if (this.array[0] && this.array[0].value) {
        return this.array[0].value
      }
    }
  }

  hide() {
    if (this.array.length) {
      this.array[0].dataset.display = this.css('display')
      this.css('display', 'none')
    }
  }

  show() {
    if (this.array.length) {
      const display = this.array[0].dataset.display
      if (display) {
        this.css('display', display)
      } else {
        this.css('display', 'block')
      }
    }
  }
}

window.Stack = Stack

function $(selector) {
  const readyRE = /complete|loaded|interactive/
  let temp

  const slice = function(elements) {
    temp = new Stack([].slice.apply(elements))
    temp[0] = temp.array[0]
    return temp
  }

  const getNode = function(selector) {
    if (typeof selector === 'string') {
      selector = selector.trim()
      temp = slice(document.querySelectorAll(selector))
      return temp
    }
  }

  if (selector && selector.type && selector.type === 'Stack') {
    return selector
  }

  if (selector === document) {
    return new Stack(document)
  }

  if (selector === null) {
    return new Stack()
  }

  if (typeof selector === 'function') {
    if (readyRE.test(document.readyState) && document.body) {
      selector.call(selector)
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        return selector.call(selector)
      })
    }
  } else if (selector && selector.nodeType === 1) {
    temp = new Stack()
    temp[0] = selector
    temp.length = temp.array.length
    temp.push(selector)
    return temp
  } else if (typeof selector === 'string') {
    if (selector === '') return new Stack()
    try {
      return getNode(selector) ? getNode(selector) : new Stack()
    } catch (err) {
      return new Stack()
    }
  } else if (Array.isArray(selector)) {
    return new Stack(selector)
  } else if (selector === window) {
    temp = new Stack()
    temp[0] = window
    temp.length = temp.array.length
    return temp
  } else {
    return new Stack()
  }

  return new Stack()
}
window.$ = $

$.extend = function(obj, prop) {
  if (!prop) {
    prop = obj
    obj = $
  }
  Object.keys(prop).forEach(function(p) {
    if (prop.hasOwnProperty(p)) {
      Object.defineProperty(obj, p, {
        value: prop[p],
        writable: true,
        enumerable: false,
        configurable: true,
      })
    }
  })
}

$.fn = {
  extend: function(object) {
    $.extend(Stack.prototype, object)
  },
}

$.extend({
  version: 'VERSION_NUMBER',

  noop: function() {
    return
  },

  uuid: function() {
    let d = Date.now()
    d += performance.now()
    const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(
      ''
    )
    const randomLetter = charset[Math.floor(Math.random() * charset.length)]
    return (
      randomLetter +
      'xxxxxxxxxxxxxxx'.replace(/[x]/g, function(c) {
        const r = ((d + Math.random() * 16) % 16) | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
    )
  },

  type: function(type) {
    switch (typeof type) {
      case 'boolean':
        return 'boolean'
      case 'number':
        return 'number'
      case 'string':
        return 'string'
      case 'function':
        return 'function'
      case 'object':
        if (Array.isArray(type)) {
          return 'array'
        } else if (Object.prototype.toString.call(type) === '[object Date]') {
          return 'date'
        } else if (Object.prototype.toString.call(type) === '[object Error]') {
          return 'error'
        } else if (Object.prototype.toString.call(type) === '[object RegExp]') {
          return 'regexp'
        } else if (Object.prototype.toString.call(type) === '[object Object]') {
          if (type.objectType && type.objectType === 'domstack') {
            return 'domstack'
            /* If Promise polyfill, then should support `then`. */
          } else if (type.then) {
            return 'promise'
            /* Otherwise we got a normal object here. */
          } else {
            return 'object'
          }
        } else if (Object.prototype.toString.call(type) === '[object Number]') {
          return 'number'
        } else if (Object.prototype.toString.call(type) === '[object String]') {
          return 'string'
        } else if (
          Object.prototype.toString.call(type) === '[object Promise]'
        ) {
          return 'promise'
        } else if (
          Object.prototype.toString.call(type) === '[object Boolean]'
        ) {
          return 'boolean'
        }
    }
  },

  escapeHTML: function(data) {
    const tagsToReplace = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '(': '%28',
      ')': '%29',
    }

    let str = JSON.stringify(data)

    const replaceTag = function(tag) {
      return tagsToReplace[tag] || tag
    }

    const safe_tags_replace = function(str) {
      return str.replace(/[&<>\(\)]/g, replaceTag)
    }

    str = safe_tags_replace(str)
    return JSON.parse(str)
  },

  camelize: function(string) {
    if (typeof string !== 'string') return
    return string.replace(/\-(.)/g, function(match, letter) {
      return letter.toUpperCase()
    })
  },

  hyphenate: function(string) {
    if (typeof string !== 'string') return
    return string.replace(/([A-Z])/g, '-$1').toLowerCase()
  },

  subscriptions: {},

  publish: function(subscription, payload) {
    const hasProp = $.subscriptions.hasOwnProperty
    if (!hasProp.call($.subscriptions, subscription)) return

    $.subscriptions[subscription].forEach(function(item) {
      item(payload != undefined ? payload : {})
    })
  },

  subscribe: function(subscription, handler) {
    if (!$.subscriptions.hasOwnProperty.call($.subscriptions, subscription))
      $.subscriptions[subscription] = []
    const index = $.subscriptions[subscription].push(handler) - 1
    return {
      off: function() {
        delete $.subscriptions[subscription][index]
      },

      run: function(data) {
        if ($.subscriptions[subscription]) {
          try {
            $.subscriptions[subscription][index](data)
          } catch (err) {}
        }
      },
    }
  },

  unsubscribe: function(subscription) {
    delete $.subscriptions[subscription]
  },

  delay: function(milliseconds) {
    return new Promise(function(resolve) {
      setTimeout(resolve, milliseconds)
    })
  },

  h: function(template) {
    const temp = document.createElement('div')
    temp.innerHTML = template
    const frag = document.createDocumentFragment()
    // Use childNodes to allow creating element nodes or text nodes:
    const children = Array.prototype.slice.apply(temp.childNodes)
    children.map(function(el) {
      frag.appendChild(el)
    })
    return frag
  },
})

function html(literals) {
  const raw = literals.raw
  let result = ''
  let i
  let len
  let sub
  let lit
  let safe

  /**
   * Function that normalizes interpolation substitions.
   * It flattens arrays while ignoring falsey values.
   * All other values are converted to strings.
   */
  function normalize(value, safe) {
    return value == null
      ? ''
      : value === false
        ? ''
        : Array.isArray(value)
          ? value.map(normalize).join('')
          : safe === false ? $.escapeHTML(value) : String(value)
  }

  for (i = 1, len = arguments.length; i < len; i++) {
    lit = raw[i - 1]
    /**
     * Allow safe html by prefixing interpolation with an exclamation mark.
     */
    safe = lit[lit.length - 1] === '!'
    sub = normalize(arguments[i], safe)
    if (safe) lit = lit.slice(0, -1)

    result += lit + sub
  }

  // Take care of last literal section.
  result += raw[raw.length - 1]

  return result
}
window.html = html

function app(callback) {
  $(function() {
    callback()
  })
}
window.app = app

$(function() {
  if (!/(mobile)|(ios)|(android)/gim.test(navigator.userAgent)) {
    document.body.classList.add('isDesktop')
  }
  if ($('link[href*=ios]')[0]) {
    document.body.classList.add('themeIsiOS')
    $.theme = 'ios'
  } else if ($('link[href*=android]')[0]) {
    document.body.classList.add('themeIsAndroid')
    $.theme = 'android'
  }
  $.dir = 'ltr'
  if (document.dir === 'rtl') {
    $.dir = 'rtl'
  }

  if (!Array.prototype.unique) {
    $.extend(Array.prototype, {
      unique: function() {
        const len = this.length
        const obj = {}
        const ret = []
        for (let i = 0; i < len; i++) {
          const arrayItem = JSON.stringify(this[i])
          const arrayItemValue = this[i]
          if (obj[arrayItem] === undefined) {
            ret.push(arrayItemValue)
            obj[arrayItem] = 1
          } else {
            obj[arrayItem]++
          }
        }
        this.length = 0
        const self = this
        ret.forEach(function(item) {
          self.push(item)
        })
      },
    })
  }
})


function html(literals) {
  let raw = literals.raw
  let result = ''
  let i
  let len
  let sub
  let lit
  let safe

  /**
   * Function that normalizes interpolation substitions.
   * It flattens arrays while ignoring falsey values.
   * All other values are converted to strings.
   */
  function normalize (val, safe) {
    return (
      val == null ? ''
      : val === false ? ''
      : Array.isArray(val) ? val.map(normalize).join('')
      : safe === false ? $.escapeHTML(val)
      : String(val)
    )
  }

  for (i = 1, len = arguments.length; i < len; i++) {
    lit = raw[i - 1]
    /**
     * Allow safe html by prefixing interpolation with an exclamation mark.
     */
    safe = lit[lit.length - 1] === '!'
    sub = normalize(arguments[i], safe)
    if (safe) lit = lit.slice(0, -1)

    result += lit + sub
  }

  // Take care of last literal section.
  result += raw[raw.length - 1]

  return result
}


$.extend({
  eventStart : null,
  eventEnd : null,
  eventMove : null,
  eventCancel : null,
  gestureLength : 30
});

$(function() {
  /* Setup Event Variables */
  /* Pointer events for IE10 and WP8: */
  if (window.navigator.pointerEnabled) {
    $.eventStart = 'pointerdown'
    $.eventEnd = 'pointerup'
    $.eventMove = 'pointermove'
    $.eventCancel = 'pointercancel'
  /* Pointer events for IE10 and WP8: */
  } else if (window.navigator.msPointerEnabled) {
    $.eventStart = 'MSPointerDown'
    $.eventEnd = 'MSPointerUp'
    $.eventMove = 'MSPointerMove'
    $.eventCancel = 'MSPointerCancel'
  /* Touch events for iOS & Android: */
  } else if ('ontouchstart' in window && /mobile/img.test(navigator.userAgent)) {
    $.eventStart = 'touchstart'
    $.eventEnd = 'touchend'
    $.eventMove = 'touchmove'
    $.eventCancel = 'touchcancel'
  /* Mouse events for desktop: */
  } else {
    $.eventStart = 'mousedown'
    $.eventEnd = 'click'
    $.eventMove = 'mousemove'
    $.eventCancel = 'mouseout'
  }
});

(function() {

  var ChuiEventCache = {
    elements: {}
  }

  /**
   * Private method to set events on ChuiEventCache
   */
  const bind = function(element, event, callback, capturePhase) {
    if (!element.id) element.id = $.uuid()
    if (!ChuiEventCache.elements[element.id]) {
      ChuiEventCache.elements[element.id] = []
    }
    ChuiEventCache.elements[element.id].push({
      event: event,
      callback: callback
    })
    element.addEventListener(event, callback, capturePhase)
  }

  /**
   * Delete items from event stack:
   */
  const deleteFromEventStack = function(toDelete, evtStck) {
    let len = toDelete.length
    for (let i = 0; len > i; len--) {
      evtStck.splice(toDelete[len - 1], 1)
    }
  }

  /**
   * Private method to unbind events on ChuiEventCache
   */
  const unbind = function(element, event, callback) {

    const eventStack = ChuiEventCache.elements[element.id]
    if (!eventStack) return
    let deleteOrder = []

    if (!event) {
      deleteOrder = []
      eventStack.forEach(function(evt, idx) {
        element.removeEventListener(evt.event, evt.callback, evt.capturePhase)
        deleteOrder.push(idx)
      })

      deleteFromEventStack(deleteOrder, eventStack)

    } else if (!!event && !callback) {
      deleteOrder = []
      eventStack.forEach(function(evt, idx) {
        if (evt.event === event) {
          element.removeEventListener(evt.event, evt.callback, evt.capturePhase)
          deleteOrder.push(idx)
        }
      })

      deleteFromEventStack(deleteOrder, eventStack)

    } else if (callback) {
      deleteOrder = []
      eventStack.forEach(function(evt, idx) {
        if (callback === evt.callback) {
          element.removeEventListener(evt.event, evt.callback, evt.capturePhase)
          deleteOrder.push(idx)
        }
      })
      deleteFromEventStack(deleteOrder, eventStack)
    }
  }

  /**
   * Set delegated events on ChuiEventCache
   */
  const delegate = function(element, selector, event, callback, capturePhase) {
    const delegateElement = $(element).array[0]
    $(element).forEach(function(ctx) {
      $(ctx).on(event, function(e) {
        let target = e.target
        if (e.target.nodeType === 3) {
          target = e.target.parentNode
        }
        $(ctx).find(selector).forEach(function(delegateElement) {
          if (delegateElement === target) {
            callback.call(delegateElement, e)
          } else {
            try {
              const ancestor = $(target).closest(selector)
              if (delegateElement === ancestor.array[0]) {
                callback.call(delegateElement, e)
              }
            } catch (err) {}
          }
        })
      }, capturePhase)
    })
  }


  /**
   * Method to remove delegated events from ChuiEventCache:
   */
  const undelegate = function(element, selector, event, callback, capturePhase) {

    unbind($(element).array[0], event, callback, capturePhase)
  }

  $.fn.extend({
    on: function(event, selector, callback, capturePhase) {
      if (!event) {
        return
      }
      if (!selector) {
        return
      }
      if (!selector && /Object/img.test(event.constructor.toString())) {
        this.forEach(function(element) {
          for (let key in event) {
            if (event.hasOwnProperty(key)) {
              $(element).on(key, event[key])
            }
          }
        })
      }
      let ret = []
      let events
      if (typeof event === 'string') {
        event = event.trim()
        if (/\s/.test(event)) {
          events = event.split(' ')
          this.forEach(function(ctx) {
            events.forEach(function(evt) {
              if (typeof selector === 'function') {
                bind(ctx, evt, selector, callback)
                ret.push(ctx)
              } else {
                delegate(ctx, selector, evt, callback, capturePhase)
              }
            })
          })
        }
      }
      this.forEach(function(ctx) {
        if (typeof selector === 'function') {
          return bind(ctx, event, selector, callback)
        } else {
          delegate(ctx, selector, event, callback, capturePhase)
        }
      })
      return this
    },

    off: function(event, selector, callback, capturePhase) {
      const ret = new Stack()
      if (!this.array.length) return ret

      this.forEach(function(ctx) {
        if (typeof event === 'undefined') {
          ret.push(ctx)
          unbind(ctx)
          return ret
        } else if (typeof selector === 'function' || !selector) {
          unbind(ctx, event, selector, callback, capturePhase)
          return this
        } else {
          undelegate(ctx, selector, event, callback, capturePhase)
          return this
        }
      })
    },

    trigger: function(event, data) {
      if (!event) {
        return
      }
      if (!this.array.length) return new Stack()
      this.forEach(function(ctx) {
        if (document.createEvent) {
          const evtObj = document.createEvent('Events')
          evtObj.initEvent(event, true, false)
          evtObj.data = data
          ctx.dispatchEvent(evtObj)
        }
      })
    }
  })
})();


(function() {
  "use strict";
  let touch = {}
  let touchTimeout
  let swipeTimeout
  let tapTimeout
  const longTapDelay = 750
  let singleTapDelay = 150
  const gestureLength = 50
  if ($.isAndroid) singleTapDelay = 200
  let longTapTimeout

  function parentIfText(node) {
    return 'tagName' in node ? node : node.parentNode
  }

  function swipeDirection(x1, x2, y1, y2) {
    return Math.abs(x1 - x2) >=
      Math.abs(y1 - y2) ? (x1 - x2 > 0 ? 'left' : 'right') : (y1 - y2 > 0 ? 'up' : 'down')
  }

  function longTap() {
    longTapTimeout = null
    if (touch.last) {
      try {
        if (touch && touch.el) {
          touch.el.trigger('longtap')
          touch = {}
        }
      } catch (err) {}
    }
  }

  function cancelLongTap() {
    if (longTapTimeout) clearTimeout(longTapTimeout)
    longTapTimeout = null
  }

  function cancelAll() {
    if (touchTimeout) clearTimeout(touchTimeout)
    if (tapTimeout) clearTimeout(tapTimeout)
    if (swipeTimeout) clearTimeout(swipeTimeout)
    if (longTapTimeout) clearTimeout(longTapTimeout)
    touchTimeout = tapTimeout = swipeTimeout = longTapTimeout = null
    touch = {}
  }

  $(function() {
    let now
    let delta
    let body = document.body
    let twoTouches = false

    body.addEventListener($.eventStart, function(e) {
      now = Date.now()
      delta = now - (touch.last || now)
      if (e.originalEvent) e = e.originalEvent

      if ($.eventStart === 'mousedown') {
        touch.el = $(parentIfText(e.target))
        if (e.target.nodeName === 'ripple') {
          touch.el = $(el.target.parentNode)
        }
        touchTimeout && clearTimeout(touchTimeout)
        touch.x1 = e.pageX
        touch.y1 = e.pageY
        twoTouches = false

      } else {
        if (e.touches.length === 1) {
          touch.el = $(parentIfText(e.touches[0].target))
          touchTimeout && clearTimeout(touchTimeout)
          touch.x1 = e.touches[0].pageX
          touch.y1 = e.touches[0].pageY
          if (e.targetTouches.length === 2) {
            twoTouches = true
          } else {
            twoTouches = false
          }
        }
      }

      if (delta > 0 && delta <= 250) {
        touch.isDoubleTap = true
      }
      touch.last = now
      longTapTimeout = setTimeout(longTap, longTapDelay)
    })

    body.addEventListener($.eventMove, function(e) {
      if (e.originalEvent) e = e.originalEvent
      cancelLongTap()
      if ($.eventMove === 'mousemove') {
        touch.x2 = e.pageX
        touch.y2 = e.pageY
      } else {

        if (e.touches.length === 1) {
          touch.x2 = e.touches[0].pageX
          touch.y2 = e.touches[0].pageY
        }
      }
    })

    body.addEventListener($.eventEnd, function() {

      cancelLongTap()
      if (!!touch.el) {
        if ((touch.x2 && Math.abs(touch.x1 - touch.x2) > gestureLength) ||
          (touch.y2 && Math.abs(touch.y1 - touch.y2) > gestureLength)) {
          swipeTimeout = setTimeout(function() {
            if (touch && touch.el) {
              touch.el.trigger('swipe')
              touch.el.trigger('swipe' + (swipeDirection(touch.x1, touch.x2, touch.y1, touch.y2)))
              touch = {}
            }
          }, 0)
        } else if ('last' in touch) {
          tapTimeout = setTimeout(function() {
            if (touch && touch.isDoubleTap) {
              if (touch && touch.el) {
                touch.el.trigger('dbltap')
                touch = {}
              }

            } else {
              touchTimeout = setTimeout(function() {
                touchTimeout = null
                if (touch && touch.el) {
                  touch.el.trigger('tap')
                  touch = {}
                  return false
                }
              }, singleTapDelay)
            }
          }, 0)
        }

      } else {
        return
      }
    })
    body.addEventListener('touchcancel', cancelAll)
  });

  ['tap', 'dbltap', 'longtap', 'swipeleft', 'swiperight', 'swipeup', 'swipedown'].forEach(function(method) {
    $.fn.extend({
      method: function(callback) {
        return this.on(method, callback)
      }
    })
  })
})()

class Component {
  constructor(options) {
    if (!options) return
    const self = this
    if (typeof options.element === 'string') {
      this.root = $(options.element)
    } else if (options.element && options.element.nodeType) {
      this.root = $(options.element)
    } else {
      this.root = options.element
    }
    this.origElement = options.element
    this.renderFnc = options.render
    this.state = options.state
    if (this.state) {
      this.state.boundComponents.push(this)
    }
    this.actions = options.actions
    this.styles = options.styles
    /* Lifecyle methods */
    if (options.componentWillMount && typeof options.componentWillMount === 'function') {
      this.componentWillMount = options.componentWillMount
    }

    if (options.componentDidMount && typeof options.componentDidMount === 'function') {
      this.componentDidMount = options.componentDidMount
    }

    if (options.componentWillUnmount && typeof options.componentWillUnmount === 'function') {
      this.componentWillUnmount = options.componentWillUnmount
    }

    if (options.componentDidUnmount && typeof options.componentDidUnmount === 'function') {
      this.componentDidUnmount = options.componentDidUnmount
    }
    
    if (options.componentWillUpdate && typeof options.componentWillUpdate === 'function') {
      this.componentWillUpdate = options.componentWillUpdate
    }

    if (options.componentDidUpdate && typeof options.componentDidUpdate === 'function') {
      this.componentDidUpdate = options.componentDidUpdate
    }

    this.chuiStyle = function() {
      let sharedSheet = null

      const unitlessProps = {
        columnCount: true,
        fillOpacity: true,
        flex: true,
        flexGrow: true,
        flexShrink: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        widows: true,
        zIndex: true,
        zoom: true
      }

      function flatten(array) {
        const flat = Array.prototype.concat(array)
        for (let i = 0; i < flat.length; i++) {
          if (Array.isArray(flat[i])) {
            flat.splice(i, 1, flat[i--])
          }
        }
        return flat
      }

      function createStyleSheet(options) {
        if (!(this instanceof createStyleSheet)) {
          return new createStyleSheet(options)
        }
        options || (options = {})
        options.prefix = !options.hasOwnProperty("prefix") ? true : !!options.prefix
        options.unit = options.hasOwnProperty("unit") ? options.unit : "px"

        this._sheet = null
        this._prefix = null

        this.css = function (element, styles, selector) {
          if (styles == null) return ""
          if (this._sheet == null) {
            this._sheet = sharedSheet = (sharedSheet || createSheet())
          }
          selector = element

          const rules = rulesFromStyles(selector, styles)
          if (options.prefix || options.unit !== "") {
            rules.forEach(function(set) {
              if (options.unit !== "") {
                addUnit(set[1], options.unit)
              }
            })
          }
          insertRules(rules, this._sheet)
        }

      }

      function createSheet() {
        if (document.head == null) {
          throw new Error("Can't add stylesheet before <head> is available. Make sure your document has a head element.")
        }
        const style = document.createElement("style")
        style.id = "styles_" + Math.random().toString(16).slice(2, 8)
        document.head.appendChild(style)
        return style.sheet
      }

      function rulesFromStyles(selector, styles) {
        if (!Array.isArray(styles)) styles = [styles]
        const style = {}
        let rules = []
        styles = flatten(styles)
        styles.forEach(function(block) {
          for (let prop in block) {
            let value = block[prop]
            if (isPlainObject(value) || Array.isArray(value)) {
              rules = rules.concat(
                rulesFromStyles(combineSelectors(selector, prop), value)
              )
            } else {
              if (prop === "content") value = "'"+value+"'"
              style[prop] = value
            }
          }
        })
        rules.push([ selector, style ])
        return rules
      }

      function insertRules(rules, sheet) {
        window.sheet = sheet
        function hyphenate(str) {
          return str.replace(/[A-Z]/g, function($0) { return '-'+$0.toLowerCase() })
        }
        rules.forEach(function(rule) {
          const pairs = []
          for (let prop in rule[1]) {
            pairs.push(hyphenate(prop) + ":" + rule[1][prop])
          }
          if (pairs.length > 0) {
            const rulez = rule[0] ? rule[0] : ''
            sheet.insertRule(rulez + "{" + pairs.join(";") + "}", 0)
          }
        })
      }

      function combineSelectors(parent, child) {
        const pseudoRe = /^[:\[]/
        const parents = parent.split(","), children = child.split(",")
        return parents.map(function(parent) {
          return children.map(function(part) {
            const separator = pseudoRe.test(part) ? "" : " "
            return parent + separator + part
          }).join(",")
        }).join(",")
      }

      function addUnit(style, unit) {
        for (let prop in style) {
          let value = style[prop] + ""
          if (!isNaN(value) && !unitlessProps[prop]) {
            value = value + unit
          }
          style[prop] = value
        }
        return style
      }

      function isPlainObject(obj) {
        return obj === Object(obj) && Object.prototype.toString === obj.toString
      }

      const stylesheets = {}
      stylesheets.css = createStyleSheet().css
      return stylesheets
    }

    this.handleEvents = function() {
      if (!this.actions) return
      const self = this
      let bubble = false
      if (this.actions.length) {
        this.actions.forEach(function(item) {
          bubble = item.bubble
          if (item && item.element === 'self' || item && !item.element) {
            self.root.on(item.event, item.callback, bubble)
          } else {
            self.root.on(item.event, item.element, item.callback, bubble)
          }
        })
      } else if ($.type(this.actions) === 'object') {
        bubble = this.actions.bubble || false
        if (!this.actions.element || this.actions.element === 'self') {
          self.root.on(this.actions.event, this.actions.callback, bubble)
        } else {
          self.root.on(this.actions.event, this.actions.element, this.actions.callback, bubble)
        }
      }
    }

    if (this.actions) {
      this.handleEvents(this.actions)
    }

    if (this.styles && (this.root && this.root.array[0])) {
      const styles = this.chuiStyle()
      if (typeof this.styles !== 'object') return
      styles.css(this.origElement, this.styles)
    }
  }

  setTemplate(template) {
    if (template) this.renderFnc = template
  }

  setState(state) {
    let self = this
    if (state) {
      if (this.state) {
        const position = state.boundComponents.findIndex((component) => self == component)
        this.state.boundComponents.splice(position, 1)
      }
      state.boundComponents.push(this)
      this.state = state
    }
  }

  render(data, append) {
    const self = this
    if (!self.renderFnc) {
      return
    }
    let temp = ''
    if (!this.root.array[0]) {
      return
    }
    if (this.componentWillUpdate) {
      this.componentWillUpdate()
    }
    if (!data && this.state) {
      data = this.state.get()
    }

    if (Array.isArray(data)) {
      data.map(function(item, idx) {
        temp += self.renderFnc(item, idx)
      }).join('')
    } else {
      temp = self.renderFnc(data)
    }

    // if (this.styles && (this.root && this.root.array[0])) {
    //   const styles = this.chuiStyle()
    //   if (typeof this.styles !== 'object') return
    //   styles.css(this.origElement, this.styles)
    // }

    if (append) {
      self.root.append(temp)
    } else {
      this.root.array[0].textContent = ''
      self.root.empty()
      self.root.append(temp)
    }
    if (this.componentDidUpdate) {
      this.componentDidUpdate()
    }
  }

  empty() {
    if (this.root.array[0]) {
      this.root.empty()
    }
  }

  mount() {
    if (this.componentWillMount) {
      this.componentWillMount()
    }
    this.root = $(this.origElement)
    this.handleEvents()
    const styles = this.chuiStyle()
    styles.css(this.origElement, this.styles)
    if (this.componentDidMount) {
      this.componentDidMount()
    }
  }

  unmount() {
    if (this.componentWillUnmount) {
      this.componentWillUnmount()
    }
    this.empty()
    this.root.off()
    if (this.componentDidUnmount) {
      this.componentDidUnmount()
    }
  }
}


class State {
  constructor(data) {
    let d
    if ($.type(data) === 'array') {
      d = data.slice()
    } else if ($.type(data) === 'object') {
      d = Object.create(data)
    } else {
      d = data
    }

    this.dataStore = d
    this.events = {}
    this.paused = false
    this.boundComponents = []
  }

  renderComponents() {
    if (!this.boundComponents || !this.boundComponents.length || this.paused) {
      return
    }
    this.boundComponents.forEach(function(component) {
      component.render()
    })
  }

  get(property) {
    if (property && $.type(this.dataStore) === 'object') {
      return this.dataStore[property]
    } else {
      return this.dataStore
    }
  }

  set(property, data) {
    if (data === false || data === 0 || data === '' || data) {
      this.dataStore[property] = data
      this.renderComponents()
    } else {
      this.dataStore = property
      this.renderComponents()
    }
  }

  purge() {
    if ($.type(this.dataStore) === 'object') {
      this.dataStore = {}
    } else if ($.type(this.dataStore) === 'array') {
      this.dataStore = []
    } else if ($.type(this.dataStore) === 'string') {
      this.dataStore = ''
    } else if (typeof this.dataStore === 'number') {
      this.dataStore = NaN
    } else if ($.type(this.dataStore === 'boolean')) {
      this.dataStore = undefined
    }
  }

  merge(obj) {
    if (!obj || typeof obj !== 'object') {
      return
    } else if (typeof this.dataStore === 'object') {
      for (let key in obj) {
        this.dataStore[key] = obj[key]
      }
      this.renderComponents()
    }
  }

  mixin(data) {
    if (!data) {
      return
    } 
    if ($.type(this.dataStore) === 'array') {
      this.dataStore = this.dataStore.concat(data).unique()
      this.renderComponents()
    } else if ($.type(this.dataStore) === 'object') {
      for (let key in data) {

        if (!(key in this.dataStore)) {
          this.dataStore[key] = data[key]
          this.renderComponents()
        }
      }
    }
  }

  replace(data) {
    if (data) {
    let d
    if ($.type(data) === 'array') {
      d = data.slice()
    } else if ($.type(data) === 'object') {
      d = Object.create(data)
    } else {
      d = data
    }
      this.dataStore = d
      this.renderComponents(this)
    }
  }

  remove(prop) {
    if (!prop) {
      return
    }
    if ($.type(this.dataStore) !== 'object') return
    delete this.dataStore[prop]
    this.renderComponents()
  }

  getPropAt(property, position) {
    if (!property || position === undefined) {
      return
    }
    if ($.type(this.dataStore) === 'array') {
      if (position < 0) {
        const pos = this.dataStore.length + position
        return this.dataStore[pos][property]
      } else if (position > this.dataStore.length) {
        return
      } else {
        return this.dataStore[position][property]
      }
    }
  }

  setPropAt(property, value, position) {
    if (!property || value === undefined || position=== undefined) {
      return
    }
    if ($.type(this.dataStore) === 'array') {
      if (position < 0) {
        const pos = this.dataStore.length + position
        this.dataStore[pos][property] = value
        this.renderComponents()
      } else {
        this.dataStore[position][property] = value
        this.renderComponents()
      }
    }
  }

  push(data) {
    if (!data) {
      return
    }
    if ($.type(this.dataStore) === 'array') {
      this.dataStore.push(data)
      this.renderComponents()
    }
  }

  pop() {
    if ($.type(this.dataStore) === 'array') {
      this.dataStore.pop()
      this.renderComponents()
    }
  }

  unshift(data) {
    if (!data) {
      return
    } else if ($.type(this.dataStore) === 'array') {
      this.dataStore.unshift(data)
      this.renderComponents()
    }
  }

  shift() {
    if ($.type(this.dataStore) === 'array') {
      this.dataStore.shift()
      this.renderComponents()
    }
  }


  slice(start, end) {
    if (end === undefined || start === undefined) {
      return
    }
    if ($.type(this.dataStore) === 'array') {
      return this.dataStore.slice(start, end)
    }
  }

  splice(start, end, data) {
    if (end === undefined || start === undefined) {
      return
    }
    if ($.type(this.dataStore) === 'array' && data) {
      this.dataStore.splice(start, end, data)
      this.renderComponents()
    } else if ($.type(this.dataStore) === 'array') {
      if(start == null || !end) return
      this.dataStore.splice(start, end)
      this.renderComponents()
    }
  }

  insert(position, data) {
    if (data === undefined || position === undefined || typeof position !== 'number') {
      return
    }
    if (typeof this.dataStore === 'array') {
      if ($.type(position) !== 'number') return
      this.dataStore.splice(position, 0, data)
      this.renderComponents()
    }
  }

  pluck(property) {
    if (!property) {
      return
    } else {
      const ret = []
      if (this.dataStore && this.dataStore.length) {
        const len = this.dataStore.length
        for (let i = 0; i < len; i++) {
          ret.push(this.dataStore[i][property])
        }
        return ret
      }
    }
  }

  indexOf(element, startFrom) {
    if (!element) {
      return
    } else if ($.type(this.dataStore) === 'array') {
      return this.dataStore.indexOf(element, startFrom)
    }
  }

  find(callback) {
    if (!callback) {
      return
    } else if ($.type(this.dataStore) === 'array') {
      return this.dataStore.find(callback)
    }
  }

  findIndex(callback) {
    if (!callback) {
      return
    } else if ($.type(this.dataStore) === 'array') {
      return this.dataStore.findIndex(callback)
    }
  }

  forEach(callback) {
    if (!callback) {
      return
    }
    if (this.dataStore && this.dataStore.length) {
      let value
      let i = -1
      const len = this.dataStore.length
      while (++i < len) {
        value = callback.call(this.dataStore[i], this.dataStore[i], i)
        if (value === false) {
          break
        }
      }
    }
  }

  filter(...args) {
    for (let _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key]
    }
    if (this.dataStore && this.dataStore.length) {
      return this.dataStore.filter.apply(this.dataStore, args)
    }
  }

  map(...args) {
    for (let _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key]
    }
    if (this.dataStore && this.dataStore.length) {
      return this.dataStore.map.apply(this.dataStore, args)
    }
  }

  reverse() {
    if (this.dataStore && this.dataStore.length) {
      this.dataStore.reverse()
      this.renderComponents()
    }
  }

  sort(compareFunction) {
    if (this.dataStore && this.dataStore.length) {
      if (compareFunction) {
        this.dataStore.sort(compareFunction)
        this.renderComponents()
      } else {
        this.dataStore.sort()
        this.renderComponents()
      }
    }
  }

  orderBy(...props) {
    for (let _len = arguments.length, _key = 0; _key < _len; _key++) {
      props[_key] = arguments[_key]
    }
    if (!props) return

    const orderBy = function() {
      return function(a, b) {
        const sortByProperty = function(property) {
          let sortOrder = 1
          if (property[0] === "-") {
            sortOrder = -1
            property = property.substr(1)
          }
          return function(a, b) {
            const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
            return result * sortOrder
          }
        }

        let i = 0
        let result = 0
        const numberOfProperties = props.length
        while (result === 0 && i < numberOfProperties) {
          result = sortByProperty(props[i])(a, b)
          i++
        }
        return result
      }
    }
    if (this.dataStore && this.dataStore.length) {
      this.dataStore.sort(orderBy.apply(null, props))
      this.renderComponents()
    }
  }

  concat(data) {
    if (!data) {
      return
    }
    if ($.type(this.dataStore) === 'array') {
      const temp = this.dataStore.concat(data)
      this.dataStore = temp
      this.renderComponents()
    }
  }

  unique() {
    if ($.type(this.dataStore) === 'array') {
      this.dataStore.unique()
      this.renderComponents()
    }
  }

  eq(position) {
    if ($.type(this.dataStore) === 'array') {
      return this.dataStore[position]
    }
  }

  size() {
    if ($.type(this.dataStore) === 'array') {
      return this.dataStore.length
    } else {
      return
    }
  }
}

$.extend($, {
  isiPhone: /iphone/img.test(navigator.userAgent),
  isiPad: /ipad/img.test(navigator.userAgent),
  isiPod: /ipod/img.test(navigator.userAgent),
  isiOS: /ip(hone|od|ad)/img.test(navigator.userAgent),
  isAndroid: (/android/img.test(navigator.userAgent) && !/trident/img.test(navigator.userAgent)),
  isTouchEnabled: !/trident/img.test(navigator.userAgent) && !/edge/img.test(navigator.userAgent) && 'createTouch' in document,
  isStandalone: navigator.standalone || false,
  isWebkit: (!/trident/img.test(navigator.userAgent) && !/edge/img.test(navigator.userAgent) && /webkit/img.test(navigator.userAgent)),
  isDesktop: (!/mobile/img.test(navigator.userAgent)),
  isMobile: (/mobile/img.test(navigator.userAgent)),
  isSafari: (!/edge/img.test(navigator.userAgent) && !/Chrome/img.test(navigator.userAgent) && /Safari/img.test(navigator.userAgent) && !/android/img.test(navigator.userAgent)),
  isChrome: !/trident/img.test(navigator.userAgent) && !/edge/img.test(navigator.userAgent) && /Chrome/img.test(navigator.userAgent) && !((/samsung/img.test(navigator.userAgent) || /Galaxy Nexus/img.test(navigator.userAgent) || /HTC/img.test(navigator.userAgent) || /LG/img.test(navigator.userAgent)) && !/trident/img.test(navigator.userAgent) && !/edge/img.test(navigator.userAgent) && /android/i.test(navigator.userAgent) && /webkit/i.test(navigator.userAgent)),
  isNativeAndroid: ((/samsung/img.test(navigator.userAgent) || /Galaxy Nexus/img.test(navigator.userAgent) || /HTC/img.test(navigator.userAgent) || /\sLG/img.test(navigator.userAgent)) && !/trident/img.test(navigator.userAgent) && !/edge/img.test(navigator.userAgent) && /android/i.test(navigator.userAgent) && /webkit/i.test(navigator.userAgent) && (/Android 3/i.test(userAgentHTC) || /Android 4/i.test(navigator.userAgent)))
})
